import React,{useEffect, useState, useCallback} from 'react'
import {Link} from 'react-router-dom'
import { Card, Row, Col, Container, Button, Modal } from 'react-bootstrap';
import 'date-fns'
import Grid from '@material-ui/core/Grid'
import DateFnsUtils from '@date-io/date-fns'
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker
} from '@material-ui/pickers'

const Admin = (props) =>{
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [selectedTime, setSelectedTime] = useState(new Date())
    const [selectedEndDate, setSelectedEndDate] = useState(new Date())
    const [selectedEndTime, setSelectedEndTime] = useState(new Date())
    const [errors,setErrors] = useState(false)
    const [contestData, setContestData] = useState({})
    const [showModal, setShowModal] = useState(false)
    const [contestName, setContestName] = useState()
     const modalHandler = () =>{
         setShowModal(!showModal)
     }
    const {handleLogout} = props
    
    const handleDateChange = (date) =>{
        setSelectedDate(date)
    }
    const handleTimeChange = (date) =>{
        setSelectedTime(date)
    }
    const handleEndDateChange = (date) =>{
        setSelectedEndDate(date)
    }
    const handleEndTimeChange = (date) =>{
        setSelectedEndTime(date)
    }
    
    
    
    function makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }


    const createContestHandler = async() =>{
        const uniqueId = makeid(4)
        const z  = contestName.replace(/ /g,'_') +"_"+ uniqueId
        if(contestName && selectedDate && selectedTime && selectedEndDate && selectedEndTime ){
            if(selectedDate < selectedEndDate ){
                    setErrors(false)
                    const startDate = selectedDate.toLocaleDateString('en-US')
                    const startTime = selectedTime.toLocaleTimeString('en-US')
                    const endDate = selectedEndDate.toLocaleDateString('en-US')
                    const endTime = selectedEndTime.toLocaleTimeString('en-US')
                    await fetch(`https://codezap-e156b.firebaseio.com/contests/${z}.json`,{
                    method:'PATCH',
                    headers:{
                        'Content-Type':'application/json'
                    },
                    body:JSON.stringify({
                    "uniqueId":uniqueId,
                    "Start_Time":[startDate,startTime],
                    "End_Time":[endDate,endTime]
                    })
                })
                loadData()
                window.location.reload(false);
                setShowModal(false)
            }
            else if(selectedDate.getTime() === selectedEndDate.getTime() && selectedTime < selectedEndTime){
                setErrors(false)
                const startDate = selectedDate.toLocaleDateString('en-US')
                const startTime = selectedTime.toLocaleTimeString('en-US')
                const endDate = selectedEndDate.toLocaleDateString('en-US')
                const endTime = selectedEndTime.toLocaleTimeString('en-US')
                await fetch(`https://codezap-e156b.firebaseio.com/contests/${z}.json`,{
                method:'PATCH',
                headers:{
                    'Content-Type':'application/json'
                },
                body:JSON.stringify({
                "uniqueId":uniqueId,
                "Start_Time":[startDate,startTime],
                "End_Time":[endDate,endTime]
                })
            })
            loadData()
            window.location.reload(false);
            setShowModal(false)
            }
            else{
                setErrors(true)    
            }
        }
        else{
            setErrors(true)
        }
        //setShowModal(!showModal)
        
        
    }
    
   
    
    const loadData = useCallback(async () =>{
        
        const response = await fetch('https://codezap-e156b.firebaseio.com/contests.json')
        const resData = await response.json()
        if(resData){
        var Map = {}
        for(var key in resData){
            var nowDate = new Date()
                var starttime = timeConvertor((resData[key].Start_Time)[1].split(" ").join()).replace(",","").split(":")
                var startDate = (resData[key].Start_Time)[0].replaceAll("/","-").split("-")
                var endtime = timeConvertor((resData[key].End_Time)[1].split(" ").join()).replace(",","").split(":")
                var endDate = (resData[key].End_Time)[0].replaceAll("/","-").split("-")
                var startDateTime = new Date(startDate[2],parseInt(startDate[0])-1,startDate[1],starttime[0],starttime[1],starttime[2])
                var endDateTime = new Date(endDate[2],parseInt(endDate[0])-1,endDate[1],endtime[0],endtime[1],endtime[2])
            
            if(nowDate <= endDateTime && nowDate >= startDateTime){
                    
                
                
                Map[key] = {
                    "End_Time":endDateTime,
                    "Start_Time":startDateTime,
                    "status":"Live"
                }
                
            }
            else if(nowDate <= startDateTime){
                
                
                Map[key] = {
                    "End_Time":endDateTime,
                    "Start_Time":startDateTime,
                    "status":"Upcoming"
                }
                
                
            }
            else{
                Map[key] = {
                    "End_Time":endDateTime,
                    "Start_Time":startDateTime,
                    "status":"Ended"
                }
            }
            
        }
        await setContestData(Map)
        }
        
        
    },[])
    
    useEffect(() =>{
        loadData()
    },[loadData])

    function timeConvertor(time) {
        var PM = time.match('PM') ? true : false
        
        time = time.split(':')
        var min = time[1]
        var hour
        var sec
        if (PM) {
            hour = 12 + parseInt(time[0],10)
            sec = time[2].replace('PM', '')
        } else {
            hour = time[0]
            sec = time[2].replace('AM', '')       
        }
        
        var t = hour + ':' + min + ':' + sec
        return t
    }

    const deleteHandler = async(id) =>{
        await fetch(`https://codezap-e156b.firebaseio.com/contests/${id}.json`,{
            method:"DELETE"
        })
        loadData()
    }
    
    return (
        <section className = "hero">
        <header className="mb-4 shadow">
        <nav className="navbar navbar-dark bg-dark primary-styled-border">
          <div className="container">
            <h1 style={{ fontSize: '2.25rem' }}>
                <span className="text-primary1">&lt;/&gt; </span>
                <span style={{ color: 'white' }}>Code</span><span className="text-primary1">Zap</span>
            </h1> 
          
            <img
                src="/logout-icon.svg"
                width={25}
                height={27}
                onClick={handleLogout}
                style = {{cursor:"pointer"}}
                alt = "logout"
            />
          </div>
        </nav>
      </header>
       
            
            <Container style = {{marginTop:"3%"}}>
            <h1>Welcome to God Mode</h1>
            <Row>
                
                    {
                        Object.keys(contestData).map(item => 
                            <Col sm = {4} key = {item} style = {{marginTop:"3%",marginBottom:"1%"}}>
                                <Card style={{ width: '100%' }}>
                                    
                                    <Card.Body>
                                        <Card.Title style = {{fontWeight:"bold", display:"flex",justifyContent:"center"}}>{item.split("_").join(" ").substring(0, item.split("_").join(" ").length - 4)}</Card.Title>
                                            <hr/>
                                                <Card.Text style = {{display:"flex",justifyContent:"center",flexDirection:"column"}}>
                                                    <div>
                                                        <span><i className="fa fa-hourglass-start" style={{color: "#343a40"}}> </i> Started on </span>
                                                        {contestData[item]["Start_Time"].toGMTString()}
                                                    </div>
                                                    <div>
                                                        <span><i className="fa fa-hourglass-end" style={{color: "#343a40"}}> </i> Ends at </span>
                                                        {contestData[item]["End_Time"].toGMTString()}
                                                    </div>
                                                </Card.Text>
                                            <hr />
                                            <p>Status : {contestData[item]["status"]}</p>
                                            <Row style = {{display:"flex", justifyContent:"space-around"}}>
                                        <Link to = 
                                            {'/contests?UCI='+item}
                                        >
                                            <Button className = "btn btn-success" style = {{ color:"white"}}>Get Started</Button>
                                        </Link>
                                        <Button className = "btn btn-danger" style = {{ color:"white", width:"38%"}} onClick = {() => deleteHandler(item)}>Delete</Button>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                            )
                    }
                    
                    
            </Row>
            <button className = "btn btn-success" id="Add" onClick = {modalHandler}  style = {{width:"20%",margin:"2%",marginLeft:"71%"}}>Create Contest</button>  
            <Modal show = {showModal} onHide = {modalHandler}>
                    <Modal.Header closeButton><h3>Create Contest</h3></Modal.Header>
                    <Modal.Body>
                    {errors ? <p>Submit form correctly</p> : <p></p>}
                    <p style = {{color:"#979faf",fontStyle:"italic"}}>Get started by providing the initial details for your contest.</p><br/>
                    <label style = {{fontWeight:"bold"}}>Contest Name<span style = {{color:"#f65039"}}>*</span></label>
                    <input
                        className = "inputM"
                        type = "text" 
                        autoFocus 
                        required 
                        value = {contestName} 
                        onChange = {(e) => setContestName(e.target.value)}
                    /> 
                    <br/><br/>
                    <MuiPickersUtilsProvider utils = {DateFnsUtils}>
                        <label style = {{fontWeight:"bold"}}>Start Time<span style = {{color:"#f65039"}}>*</span></label>
                        <Grid container justify = 'space-evenly'>
                        
                            <KeyboardDatePicker 
                            disableToolbar
                                variant = 'inline'
                                format = "MM/dd/yyy"
                                margin = "normal"
                                id = 'date-picker'
                                label = 'Date Picker'
                                value = {selectedDate}
                                onChange = {handleDateChange}
                                
                            />
                            <KeyboardTimePicker 
                                margin = "normal"
                                id = "time-picker"
                                label = 'Time Picker'
                                value = {selectedTime}
                                onChange = {handleTimeChange}
                                
                            />
                        </Grid>
                    </MuiPickersUtilsProvider>  
                    <br/><br/>
                    <MuiPickersUtilsProvider utils = {DateFnsUtils}>
                        <label style = {{fontWeight:"bold"}}>End Time<span style = {{color:"#f65039"}}>*</span></label>
                        <Grid container justify = 'space-evenly'>
                        
                            <KeyboardDatePicker 
                            disableToolbar
                                variant = 'inline'
                                format = "MM/dd/yyy"
                                margin = "normal"
                                id = 'date-picker'
                                label = 'Date Picker'
                                value = {selectedEndDate}
                                onChange = {handleEndDateChange}
                                
                            />
                            <KeyboardTimePicker 
                                margin = "normal"
                                id = "time-picker"
                                label = 'Time Picker'
                                value = {selectedEndTime}
                                onChange = {handleEndTimeChange}
                                
                            />
                        </Grid>
                    </MuiPickersUtilsProvider>  
                    </Modal.Body>
                    <Modal.Footer>
                    <button className = "btn btn-success" id="closeModal" onClick = {createContestHandler}  style = {{width:"20%",margin:"2%",marginLeft:"71%"}}>Submit</button>  
                    </Modal.Footer>
            </Modal>
            </Container>

           
        </section>
        
    )
}

export default Admin